import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { ContactOriginApiService } from '../services/contact-origin-api.service';
import { ContactOriginResponse } from '../models/contact-origin.model';
import { AuthService } from '../../auth-pages/services/auth.service';
import { ConfirmDialogService } from '../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';

@Component({
  selector: 'app-contact-origin-list',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    PageBreadcrumbComponent,
    HasPermissionDirective
  ],
  templateUrl: './contact-origin-list.component.html'
})
export class ContactOriginListComponent implements OnInit {
  origenes: ContactOriginResponse[] = [];
  loading = false;
  error = '';

  constructor(
    private originApi: ContactOriginApiService,
    private authService: AuthService,
    private router: Router,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    this.cargarOrigenes();
  }

  cargarOrigenes(): void {
    this.loading = true;
    this.error = '';

    const user = this.authService.getCurrentUser();
    const businessId = user?.businessId || 1;

    this.originApi.getOrigins(businessId).subscribe({
      next: (data) => {
        this.origenes = data;
        this.loading = false;
      },
      error: (err) => {
        this.error = err.error?.message || 'Error al cargar los orígenes de contacto';
        this.loading = false;
        console.error('Error:', err);
      }
    });
  }

  nuevoOrigen(): void {
    this.router.navigate(['/config-contactos/origenes/crear']);
  }

  editarOrigen(origen: ContactOriginResponse): void {
    this.router.navigate(['/config-contactos/origenes/editar', origen.id]);
  }

  async eliminarOrigen(origen: ContactOriginResponse): Promise<void> {
    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar origen',
      message: `¿Está seguro de eliminar el origen "${origen.name}"?`
    });
    if (!ok) return;
    const user = this.authService.getCurrentUser();
    const businessId = user?.businessId || 1;

    this.originApi.deleteOrigin(origen.id, businessId).subscribe({
      next: () => {
        this.cargarOrigenes();
        this.toast.deleted('Origen de contacto', `Se eliminó "${origen.name}" correctamente.`);
      },
      error: (err) => {
        this.toast.error({ title: 'Error', message: err.error?.message || 'Error al eliminar el origen' });
      }
    });
  }
}
